<h2 mat-dialog-title>Entrer votre OTP</h2>
<div>
    <p>
        Un otp vous a été envoyé, veuillez le fournir pour valider la transaction.
    </p>
</div>
<br> <br>
<mat-dialog-content>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>OTP</mat-label>
    <input matInput [(ngModel)]="otp" maxlength="6">
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Annuler</button>
  <button mat-flat-button color="primary" (click)="submitOtp()">Valider</button>
</mat-dialog-actions>
